export default __webpack_public_path__ + "static/media/brandontext-light.b1da3300.ttf";